<template>
  <div class="history-wrapper">
    <div class="history-item-wrapper">
      <div class="history-item"
        v-for="(item, index) in list"
        :key="index"
        @click="handleClick(item)"
      >
      <div class="top">
        <img class="img" src="~@/assets/images/super/super.png" alt="">
        <div class="name">{{item.name}}</div>
        <img class="arrow" src="~@/assets/images/super/arrow.png" alt="">
      </div>
      <div class="bottom">
        <img class="img" src="~@/assets/images/super/time.png" alt="">
        <div class="timename">申请时间</div>
        <div class="time">{{formatTime(item.createTime)}}</div>
      </div>
     </div>
    </div>
    <div class="empty" v-if="list.length === 0">
      <img class="img" src="~@/assets/images/super/empty.png" alt="">
    </div>
  </div>
</template>
<script>
import { getHistory } from '@/api/super'
import { setStore, removeStore, formatTime } from '@/utils/index'

export default {
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.detailId = this.$route.query.detailId
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
      this.token = token
    }
    this.getList()
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    formatTime: formatTime,
    getList () {
      getHistory().then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          this.list = res.data.result
        }
      }).catch(() => {

      })
    },
    handleClick (item) {
      let id = item.id
      this.$router.push({ name: 'scode',
        query: {
          detailId: id,
          token: this.token
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.history-wrapper {
  min-height: 100vh;
}
.history-item {
  padding: 15px;
  border-bottom: 1px solid #f1f1f1;
  background: #fff;
  line-height: 1.6;
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }
  .bottom {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #757575;
  }
  .img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  .name {
    flex: 1;
    font-size: 16px;
    color: #333;
  }
  .timename {
    flex: 1;
  }
  .arrow {
    width: 12px;
  }
}
.empty {
  display: flex;
  justify-content: center;
  padding-top:100px;
  .img {
    width: 146px;
    height: 91px;
  }
}
</style>
